import { StrictMode } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router';
import { ToastContainer } from 'react-toastify';

import App from '@/App';
import { oidcConfig } from '@/auth';
import { ErrorBoundary } from '@/components';

const rootElement = document.getElementById(import.meta.env.VITE_APP_ROOT_ELEMENT_ID ?? 'root');
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(rootElement!).render(
  <StrictMode>
    <AuthProvider {...oidcConfig}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary>
            <App />
            <ToastContainer position="top-right" autoClose={5000} />

            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
          </ErrorBoundary>
        </QueryClientProvider>
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>,
);
